import React from 'react';

export interface SelectOption {
  label: string;
  value: string;
}

export function renderSelectedObjects(selectedObjects?: SelectOption[]) {
  return selectedObjects ? (
    <div className="objectList">
      <ul>
        {selectedObjects.map((obj: SelectOption) => (
          <li key={obj.value}>{obj.label}</li>
        ))}
      </ul>
      <style jsx>{`
        .objectList {
          border-color: #d9d9d9 #ccc #b3b3b3;
          border-radius: 4px;
          border: 1px solid #ccc;
          color: #333;
        }
      `}</style>
    </div>
  ) : undefined;
}
